import React, { useEffect, useState } from 'react';
import Button from '../../components/Button/Button';
import { Link, useNavigate } from 'react-router-dom';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { format, set } from 'date-fns';
import { bankInfo, currency, invoiceItem } from '../../utils/constant';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import useFormValidation from '../../hooks/useFormValidation';
import { accomodationFormValidationSchema } from '../../utils/formValidation';
import { normalizeDate, convertToSubcurrency } from '../../utils/utility';
import { getPassportById } from '../../services/studentApi';
import { errorToast } from '../../utils/errorHandling';
import { AiOutlineLoading } from 'react-icons/ai';
import { toast } from 'react-toastify';
import { getAccommodationForm, getAccommodationRoomQuantity, topUpAndRefund, updateAccommodationById } from '../../services/accomodationApi';
import { CgArrowsExchangeAlt } from "react-icons/cg";
import { FaEdit, FaFilePdf } from "react-icons/fa";
import { Tooltip } from 'react-tooltip'
import CustomModal from '../../components/CustomModal';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from '@stripe/stripe-js';
import Checkout from '../../components/Checkout';
import { PDFDocument, StandardFonts } from 'pdf-lib';
import AccommodationOption from '../../components/AccommodationOption';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const base_url = process.env.REACT_APP_BASE_URL

const ViewAccomodation = () => {
    const navigate = useNavigate();
    const [isChangeRoomModalOpen, setIsChangeRoomModalOpen] = useState(false);
    const toggleChangeRoomModal = () => {
        setIsChangeRoomModalOpen(!isChangeRoomModalOpen);
    };
    const [isAddOnBedModalOpen, setIsAddOnBedModalOpen] = useState(false);
    const toggleAddOnBedModal = () => {
        setIsAddOnBedModalOpen(!isAddOnBedModalOpen);
    };
    const [isChangeRoommateModalOpen, setIsChangeRoommateModalOpen] = useState(false);
    const toggleChangeRoommateModal = () => {
        setIsChangeRoommateModalOpen(!isChangeRoommateModalOpen);
    };
    const closeChangeRoommateModal = () => {
        setIsChangeRoommateModalOpen(false);
        setFormData(originalData);
    };
    const [isChangeStayDateModalOpen, setIsChangeStayDateModalOpen] = useState(false);
    const toggleChangeStayDateModal = () => {
        setIsChangeStayDateModalOpen(!isChangeStayDateModalOpen);
    };
    const closeChangeStayDateModal = () => {
        setIsChangeStayDateModalOpen(false);
        setIsEditing(true);
    };
    const closeChangeRoomModal = () => {
        setIsChangeRoomModalOpen(false);
        setIsEditing(true);
    };
    const { t } = useTranslation();
    const [selectedRoom, setSelectedRoom] = useState(null);
    const languageSelected = localStorage.getItem('i18nextLng');
    const courseData = localStorage.getItem("courseData")
        ? JSON.parse(localStorage.getItem("courseData"))
        : null;
    const currencyCopy = currency(t);
    const bankInfoCopy = bankInfo(t);
    const invoiceItemCopy = invoiceItem(t);
    const kingRoom1PPrice = invoiceItem(t).find((item) => item.key === "king_1p").amount;
    const kingRoom2PPrice = invoiceItem(t).find((item) => item.key === "king_2p").amount;
    const twinRoom2PPrice = invoiceItem(t).find((item) => item.key === "twin_2p").amount;
    const extendStayPrice = invoiceItem(t).find((item) => item.key === "extendStay").amount;
    const [originalRoomAmount, setOriginalRoomAmount] = useState(0);
    const [formData, setFormData] = useState(null);
    const [originalData, setOriginalData] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [passportRegion, setPassportRegion] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { errors, validateField, validateAllFields } = useFormValidation(accomodationFormValidationSchema(t, courseData));
    const [totalStayDaysBefore, setTotalStayDaysBefore] = useState(0);
    const [totalStayDaysNow, setTotalStayDaysNow] = useState(0);
    const [extendStayDay, setExtendStayDay] = useState(0);
    const [earlyStayDay, setEarlyStayDay] = useState(0);
    const [differentStayDays, setDifferentStayDays] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [roomQuantity, setRoomQuantity] = useState(null);
    const [currencySelected, setCurrencySelected] = useState({
        key: "",
        currency: "",
        rate: 1,
    });
    const [checkoutItem, setCheckoutItem] = useState({
        roomDifferentAmount: 0,
        amountDifference: 0,
        tourismTax: 0,
        sustainabilityFee: 0,
    });
    // uncomment because removal of transaction fee
    // const [transactionFee, setTransactionFee] = useState(0);
    const [totalAmount, setTotalAmount] = useState({ totalAmount: 0, totalAmountInCurrencySelected: 0 });
    const [netTotalAmount, setNetTotalAmount] = useState(0);

    const fetchPassport = async () => {
        try {
            const passportData = await getPassportById();
            if (passportData) {
                setPassportRegion(passportData.passport_region);
            }
        } catch (error) {
            console.log(error, t("Passport.warning"));
        }
    };

    const fetchRoomQuantity = async () => {
        try {
            const data = await getAccommodationRoomQuantity(courseData.id);
            setRoomQuantity(data);
            return data;
        } catch (error) {
            throw error;
        }
    };

    const fetchAccommodation = async () => {
        setIsLoading(true);
        setFormData(null);
        try {
            const data = await getAccommodationForm();
            if (data) {
                setFormData({
                    check_in_date: data.check_in_date
                        ? dayjs(data.check_in_date).utc().format("YYYY-MM-DD")
                        : "",
                    check_out_date: data.check_out_date
                        ? dayjs(data.check_out_date).utc().format("YYYY-MM-DD")
                        : "",
                    is_addon_bed: data.is_addon_bed,
                    is_early_check_in: data.is_early_check_in,
                    is_extend_stay: data.is_extend_stay,
                    is_roommate: data.is_roommate,
                    offline_payment_currency: "",
                    offline_payment_prove: "",
                    payment_mode: "",
                    room_type: data.room_type,
                    room_type_assigned: data.room_type_assigned,
                    roommate_id: data.roommate_id,
                    roommate_name: data.roommate_name,
                    roommate_relationship: data.roommate_relationship,
                });
                setOriginalData({
                    ename: data.ename,
                    is_open_download_hotel_form: data.is_open_download_hotel_form,
                    check_in_date: data.check_in_date
                        ? dayjs(data.check_in_date).utc().format("YYYY-MM-DD")
                        : "",
                    check_out_date: data.check_out_date
                        ? dayjs(data.check_out_date).utc().format("YYYY-MM-DD")
                        : "",
                    is_addon_bed: data.is_addon_bed,
                    is_early_check_in: data.is_early_check_in,
                    is_extend_stay: data.is_extend_stay,
                    is_roommate: data.is_roommate,
                    offline_payment_currency: data.offline_payment_currency,
                    offline_payment_prove: data.offline_payment_prove,
                    payment_mode: data.payment_mode,
                    room_type: data.room_type,
                    room_type_assigned: data.room_type_assigned,
                    roommate_id: data.roommate_id,
                    roommate_name: data.roommate_name,
                    roommate_relationship: data.roommate_relationship,
                    has_finance_error: data.has_finance_error
                });
                const oriStartDate = normalizeDate(data.check_in_date);
                const oriEndDate = normalizeDate(data.check_out_date);
                setOriginalRoomAmount(invoiceItem(t).find((item) => item.key == data.room_type).amount);
                setSelectedRoom(data.room_type);

                const initialTotalStayDays = ((oriEndDate - oriStartDate) / (1000 * 60 * 60 * 24)) + 1;
                setTotalStayDaysBefore(initialTotalStayDays);
                setTotalStayDaysNow(initialTotalStayDays);
                calculateStayDays("check_in_date", dayjs(data.check_in_date).utc().format("YYYY-MM-DD"));
                calculateStayDays("check_out_date", dayjs(data.check_out_date).utc().format("YYYY-MM-DD"));
            }
        } catch (error) {
            throw error;
        }
    };


    useEffect(() => {
        const init = async () => {
            try {
                await fetchAccommodation();
                await fetchPassport();
                await fetchRoomQuantity();
            } catch (error) {
                errorToast(error, t("general.Reload"), t);
            } finally {
                setIsLoading(false);
            }
        };
        init();
    }, []);

    const isRoomDisabled = (type) => {
        // the type should follow setting from db, only have double room and single room
        // 1. Check if data exists
        if (!roomQuantity || roomQuantity.length === 0) return false;

        // 2. Find the specific room type in the array
        const room = roomQuantity.find(r => r.room_type === type);

        // 3. Disable if room is found and remaining_quantity is 0 or less
        // If room type isn't found in the DB, you might want to default to disabled (true)
        return room ? room.remaining_quantity <= 0 : true;
    };

    const handleRoomSelection = (roomId) => {
        setSelectedRoom(roomId);
        setFormData((prevState) => ({
            ...prevState,
            "room_type": roomId,
            "is_roommate": roomId === "kingroom" ? "0" : prevState.is_roommate,
        }));
        validateField("room_type", roomId);

        setCheckoutItem((prevState) => ({
            ...prevState,
            roomDifferentAmount: invoiceItemCopy.find((item) => item.key === roomId)?.amount - originalRoomAmount,
        }));
    };

    useEffect(() => {
        // const room_type_price = formData?.room_type === "kingroom" ? "earlyStaySingleRoom" : "earlyStay";
        setCheckoutItem((prevState) => ({
            ...prevState,
            amountDifference: differentStayDays * invoiceItemCopy.find((item) => item.key === "earlyStay").amount,
        }));
        if (passportRegion !== "Malaysia" && passportRegion !== "") {
            setCheckoutItem((prevState) => ({
                ...prevState,
                tourismTax: differentStayDays * invoiceItemCopy.find((item) => item.key === "tourismTax").amount,
            }));
        }

        setCheckoutItem((prevState) => ({
            ...prevState,
            sustainabilityFee: differentStayDays * invoiceItemCopy.find((item) => item.key === "sustainabilityFee").amount,
        }));
    }, [differentStayDays])

    useEffect(() => {
        let totalNet = (Number(checkoutItem.amountDifference) + Number(checkoutItem.roomDifferentAmount)).toFixed(2);
        let totalSum = (Number(totalNet) + Number(checkoutItem.tourismTax) + Number(checkoutItem.sustainabilityFee)).toFixed(2);
        let totalInCurrencySelected = (Number(totalSum) * Number(currencySelected.rate)).toFixed(2);
        setNetTotalAmount(totalNet);
        setTotalAmount({
            totalAmount: totalSum,
            totalAmountInCurrencySelected: totalInCurrencySelected
        });
    }, [checkoutItem, currencySelected]);

    // uncomment because removal of transaction fee
    // useEffect(() => {
    //     setTransactionFee(paymentMethod === "creditcard" ? ((0.04 * (Number(netTotalAmount) + Number(checkoutItem.tourismTax)) + 1) / 0.96).toFixed(2) : 0);
    // }, [totalAmount, paymentMethod]);

    const handleCurrencyChange = (e) => {
        const { id, value } = e.target;
        const currencyInfo = currencyCopy.filter((item) => item.key === value);
        setCurrencySelected({
            key: currencyInfo.length >= 1 ? currencyInfo[0].key : "",
            currency: currencyInfo.length >= 1 ? currencyInfo[0].currency : "",
            rate: currencyInfo.length >= 1 ? currencyInfo[0].rate : 1
        });
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
        validateField(id, value)
    }

    const handleCancel = () => {
        window.location.reload();
    };

    const [previews, setPreviews] = useState({});
    const [fileError, setFileError] = useState(null);
    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    const handleFileChange = (event) => {
        const { id } = event.target;
        const selectedFile = event.target.files[0];
        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "application/pdf",
            "image/jpg",
            "image/heic"
        ];
        if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
            setFileError(t("FormValid.FileExtensionAllow"));
            event.target.value = ""; // Clear the file input
            setPreviews((prev) => ({ ...prev, [id]: null }));
            return;
        } else if (selectedFile && selectedFile.size > maxSize) {
            setFileError((prevState) => ({
                ...prevState,
                [id]: t("FormValid.smallerFile10MB"),
            }));
            event.target.value = ""; // Clear the file input
            setPreviews((prev) => ({ ...prev, [id]: null }));
            return;
        }
        setFileError((prevState) => ({
            ...prevState,
            [id]: null,
        }));

        setFormData((prevState) => ({
            ...prevState,
            [id]: selectedFile,
        }));

        if (selectedFile && selectedFile.type.startsWith("image/")) {
            const previewUrl = URL.createObjectURL(selectedFile);
            setPreviews((prev) => ({
                ...prev,
                [id]: previewUrl,
            }));
        } else {
            // If PDF or non-image → no preview
            setPreviews((prev) => ({
                ...prev,
                [id]: null,
            }));
        }

        validateField(id, selectedFile);
    };

    const setNullFormToEmpty = (nullFormData) => {
        for (const [key, value] of Object.entries(nullFormData)) {
            if (value === null || value === undefined) {
                nullFormData[key] = ''; // Replace with an empty string
            }
        }
        return nullFormData;
    }
    const generateValidationFields = () => {
        let validationFields = ["room_type", "is_roommate", "check_in_date", "check_out_date"];
        formData.is_roommate === "1" && validationFields.push("roommate_id", "roommate_name", "roommate_relationship");
        if (netTotalAmount > 0) {
            if (checkoutItem.amountDifference + checkoutItem.roomDifferentAmount > 0) {
                validationFields.push("payment_mode");
            }
            formData.payment_mode === "offline" &&
                validationFields.push("offline_payment_currency", "offline_payment_prove")
        }
        return validationFields;
    }

    const isFull = async () => {
        const freshData = await fetchRoomQuantity(courseData.id);
        let dbSearchType = formData.room_type;
        if (formData.room_type === "twin_2p" || formData.room_type === "king_2p") {
            dbSearchType = "doubleroom";
        } else if (formData.room_type === "king_1p") {
            dbSearchType = "singleroom";
        }
        const matchedRoom = freshData.find(r => r.room_type === dbSearchType);
        return matchedRoom ?
            formData.room_type !== originalData.room_type ? matchedRoom.remaining_quantity <= 0 : false : true;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        let transformedFormData = setNullFormToEmpty(formData);
        let validationFields = generateValidationFields();
        try {
            if (validateAllFields(transformedFormData, validationFields)) {
                // check again room availability before submitting
                const isRoomFull = await isFull();

                if (isRoomFull) {
                    setIsSubmitting(false);
                    toast.error(t("accomodation.RoomUnavailable"));
                    return;
                } else {
                    const combinedFormData = {
                        ...formData,
                        ...checkoutItem,
                        ...totalAmount,
                        // transactionFee: transactionFee,
                        netTotalAmount: netTotalAmount,
                        payment_type: netTotalAmount < 0 ? "Refund" : "Top-Up"
                    };
                    const response = await topUpAndRefund(combinedFormData);
                    if (response) {
                        toast.success(t("accomodation.RequestDone"));
                        setTimeout(() => {
                            window.location.reload();
                        }, 500);
                    }
                }
            } else {
                toast.error(t("general.ValidationFail"));
                setIsSubmitting(false); // Re-enable the button
                return;
            }

        } catch (error) {
            // General error handling
            errorToast(error, t("general.Error"), t);
        } finally {
            // Ensure the button is re-enabled regardless of outcome
            setIsSubmitting(false);
        }
    };

    const handleInputChange = (e) => {
        const { id, value, name } = e.target;

        if (name === "is_addon_bed" || name === "payment_mode") {
            setFormData((prevState) => ({
                ...prevState,
                [name]: id,
            }));
            if (name === "payment_mode") {
                setPaymentMethod(id);
                setCurrencySelected({
                    key: "",
                    currency: "",
                    rate: 1
                });
            }
            validateField(name, id);
        } else if (name === "is_roommate") {
            if (id === "1") {
                setFormData((prevState) => ({
                    ...prevState,
                    [name]: id,
                }));
            } else {
                setFormData((prevState) => ({
                    ...prevState,
                    [name]: id,
                    roommate_id: "",
                    roommate_name: "",
                    roommate_relationship: ""
                }));
            }
        } else if (id === "check_in_date" || id === "check_out_date") {
            setFormData((prevState) => ({
                ...prevState,
                [id]: value,
            }));
            validateField(id, value);
            calculateStayDays(id, value);
        } else {
            setFormData((prevState) => ({
                ...prevState,
                [id]: value,
            }));
            validateField(id, value);
        }
    };

    const calculateStayDays = (id, value) => {
        let earlyStayDayVar = 0;
        let extendStayDayVar = 0;
        if (id === "check_in_date") {
            const desiredStartDate = normalizeDate(value);
            const startDate = normalizeDate(
                dayjs(courseData.start_datetime)
                    .utc()
                    .format("YYYY-MM-DD")
            );
            earlyStayDayVar = (startDate - desiredStartDate) / (1000 * 60 * 60 * 24);// Convert milliseconds to days
            setFormData((prevState) => ({
                ...prevState,
                is_early_check_in: earlyStayDayVar !== 0 ? 1 : 0,
            }))

            setEarlyStayDay(earlyStayDayVar);
        } else {
            const desiredEndDate = normalizeDate(value);
            const endDate = normalizeDate(
                dayjs(courseData.end_datetime)
                    .utc()
                    .format("YYYY-MM-DD")
            );
            extendStayDayVar = (desiredEndDate - endDate) / (1000 * 60 * 60 * 24);
            setFormData((prevState) => ({
                ...prevState,
                is_extend_stay: extendStayDayVar !== 0 ? 1 : 0,
            }))

            setExtendStayDay(extendStayDayVar);
        }
    }

    useEffect(() => {
        calculateDifferentStayDays();
    }, [earlyStayDay, extendStayDay, totalStayDaysBefore]);

    const calculateDifferentStayDays = () => {
        setTotalStayDaysNow(
            (earlyStayDay + extendStayDay + 7)
        );

        setDifferentStayDays(
            ((earlyStayDay + extendStayDay + 7) - totalStayDaysBefore)
        );
    }

    const handleUpdate = async (flag, closeModal) => {
        setIsSubmitting(true);
        let updateFormData = {};
        let formKey = [];
        switch (flag) {
            // case "roomChange":
            //     updateFormData = { "room_type": formData.room_type === "twinroom" ? "kingroom" : "twinroom" };
            //     formKey = Object.keys(updateFormData);
            //     break;
            case "addOnBed":
                updateFormData = { "is_addon_bed": formData.is_addon_bed === "1" ? "0" : "1" };
                formKey = Object.keys(updateFormData);
                break;
            case "roommateChange":
                updateFormData = {
                    "is_roommate": formData.is_roommate,
                    "roommate_id": formData.roommate_id,
                    "roommate_name": formData.roommate_name,
                    "roommate_relationship": formData.roommate_relationship
                };
                if (formData.is_roommate === "1") {
                    formKey = Object.keys(updateFormData);
                } else {
                    formKey = ["is_roommate"];
                }
                break;
        }
        if (validateAllFields(updateFormData, formKey)) {
            try {
                const response = await updateAccommodationById(updateFormData);
                if (response) {
                    toast.success(t("accomodation.RequestChange"));
                    fetchAccommodation();
                    closeModal();
                }
            } catch (error) {
                errorToast(error, t("general.failSubmit"), t);
            } finally {
                setIsSubmitting(false);
            }
        } else {
            toast.error(t("general.ValidationFail"));
            setIsSubmitting(false);
        }
    }

    const handleDownloadConfirmation = async () => {

        // This helper fixes common Chinese-keyboard input issues
        const cleanForPDF = (str) => {
            if (!str) return "";
            return str
                .normalize("NFKC") // 1. CONVERTS Full-width "，" to "," and "’" to "'"
                .replace(/[\u2018\u2019]/g, "'") // 2. Specific fix for different types of smart quotes
                .replace(/[\u200B-\u200D\uFEFF]/g, "") // 3. Removes invisible ghosts
                // 4. This regex keeps all standard English letters, numbers, and common symbols:
                // Includes: ! " # $ % & ' ( ) * + , - . / : ; < = > ? @ [ \ ] ^ _ ` { | } ~
                .replace(/[^\x20-\x7E]/g, "")
                .trim();
        };

        const safeEname = cleanForPDF(originalData.ename);
        const roomTypeText = invoiceItemCopy.find(i => i.key === originalData?.room_type)?.titleForHotelDocDownload;
        // Update your check to use the cleaned name
        if (!safeEname || !originalData.check_in_date || !originalData.check_out_date || !roomTypeText) {
            toast.error(t("accomodation.FailedToDownloadPDF"));
            return;
        }
        // Show loading state
        toast.info(t("accomodation.GeneratingPDF"));

        try {
            // Load the PDF template
            const templateUrl = `${base_url}/pdf_template/hotel_confirmation.pdf`;
            const templateBytes = await fetch(templateUrl).then(res => {
                if (!res.ok) {
                    throw new Error(`Failed to fetch template: ${res.status} ${res.statusText}`);
                }
                return res.arrayBuffer();
            });

            // Load the PDF document
            const pdfDoc = await PDFDocument.load(templateBytes);

            // Get the first page
            const pages = pdfDoc.getPages();
            if (pages.length === 0) {
                throw new Error('PDF template has no pages');
            }
            const firstPage = pages[0];

            // Get the standard font
            const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
            const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

            // Set text properties
            const fontSize = 11;

            // Get page dimensions to help with positioning
            const { width, height } = firstPage.getSize();

            // Add user information to the PDF
            // Adjust these values based on the actual template

            // Guest Name - Position next to  "Guest Name:"
            firstPage.drawText(safeEname || '', {
                x: 390,
                y: height - 200, // Positioning from top
                size: fontSize,
                font: boldFont,
            });

            // Check-in date - Position next to "Arrival Date："
            firstPage.drawText(originalData.check_in_date, {
                x: 450,
                y: height - 358, // Positioning from top
                size: fontSize,
                font,
            });

            // Check-out date - Position next to "Departure Date:""
            firstPage.drawText(originalData.check_out_date, {
                x: 460,
                y: height - 410, // Positioning from top
                size: fontSize,
                font,
            });

            // Room type - Position next to "房间类型："
            // 1. Get the text and split it by the newline character
            const lines = roomTypeText.split('\n');

            // 2. Define your starting position and custom line height
            const startX = 465;
            const startY = height - 463;
            const customLineHeight = 14; // Adjust this number (lower = tighter space)

            // 3. Draw each line individually
            lines.forEach((line, index) => {
                firstPage.drawText(line.trim(), {
                    x: startX,
                    y: startY - (index * customLineHeight), // Subtracts height for each new line
                    size: fontSize,
                    font: font,
                });
            });

            // Save the PDF with options
            const pdfBytes = await pdfDoc.save({
                useObjectStreams: false // This can help with compatibility
            });

            // Create a blob from the PDF bytes with explicit MIME type
            const blob = new Blob([pdfBytes], {
                type: 'application/pdf;charset=utf-8'
            });

            // Create a download link and trigger download
            const fileName = `hotel_confirmation_${originalData.ename}.pdf`;

            try {
                // Try using the download attribute first
                const link = document.createElement('a');
                const url = window.URL.createObjectURL(blob);

                // Set link properties
                link.href = url;
                link.download = fileName;
                link.type = 'application/pdf';
                link.style.display = 'none';

                // Add to document, click, and cleanup
                document.body.appendChild(link);

                // Use a promise to handle the click event
                await new Promise((resolve) => {
                    link.onclick = resolve;
                    link.click();
                });

                // Cleanup after a short delay
                setTimeout(() => {
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                }, 1000);

                // Show success message
                toast.success(t("accomodation.PDFDownloaded"));
            } catch (downloadError) {
                // Fallback: Try opening in a new window
                console.warn('Download failed, trying fallback method:', downloadError);
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank');

                // Cleanup URL after a delay
                setTimeout(() => {
                    window.URL.revokeObjectURL(url);
                }, 1000);

                toast.info(t("accomodation.PDFOpenedInNewTab"));
            }
        } catch (error) {
            console.error('Error generating PDF:', error);
            toast.error(`${t("accomodation.FailedToDownloadPDF")}: ${error.message}`);
        }
    };

    return (
        <>
            {/* <CustomModal
                hideModal={toggleChangeRoomModal}
                open={isChangeRoomModalOpen}
                performAction={() => handleUpdate("roomChange", toggleChangeRoomModal)}
                title={t("accomodation.UpdateInformation")}
                confirmLoading={isSubmitting}
                children={
                    <p>
                        {t("accomodation.ChangeROOM")} {formData?.room_type === "twinroom" ? t("Constant.KingRoom") : t("Constant.TwinRoom")}?
                    </p>
                }
            /> */}
            <CustomModal
                hideModal={toggleChangeRoomModal}
                open={isChangeRoomModalOpen}
                // performAction={() => navigate(`${base_url}/topup-refund-accommodation`)}
                performAction={closeChangeRoomModal}
                title={t("accomodation.UpdateInformation")}
                children={
                    <p>
                        {t("accomodation.ConfirmationChangeRoom")}
                    </p>
                }
            />
            <CustomModal
                hideModal={toggleAddOnBedModal}
                open={isAddOnBedModalOpen}
                performAction={() => handleUpdate("addOnBed", toggleAddOnBedModal)}
                title={t("accomodation.UpdateInformation")}
                confirmLoading={isSubmitting}
                children={
                    <p>
                        {t("accomodation.Sure")} {formData?.is_addon_bed === "1" && <span className='error'>{t("general.BTNcancel")}</span>} {t("accomodation.AddON")}?
                    </p>
                }
            />
            <CustomModal
                hideModal={closeChangeRoommateModal}
                open={isChangeRoommateModalOpen}
                performAction={() => handleUpdate("roommateChange", toggleChangeRoommateModal)}
                title={t("accomodation.RoommateModified")}
                confirmLoading={isSubmitting}
                children={
                    <>
                        <div className="form-item">
                            <label>{t("accomodation.Roommate_Question")}
                                <span style={{ "color": "#ff0000" }}>*</span></label>
                            <div className='radio'>
                                <input
                                    className="form-check-input p-2"
                                    type="radio"
                                    name="is_roommate"
                                    id="1"
                                    checked={formData?.is_roommate === "1"}
                                    onChange={handleInputChange}
                                    required
                                />
                                <p className='radioLabel mb-0'>{t("general.yes")}</p>
                            </div>
                            <div className='radio'>
                                <input
                                    className="form-check-input p-2"
                                    type="radio"
                                    name="is_roommate"
                                    id="0"
                                    checked={formData?.is_roommate === "0"}
                                    onChange={handleInputChange}
                                    required
                                />
                                <p className='radioLabel mb-0'>{t("accomodation.roomArrange")}</p>
                            </div>
                        </div>
                        {errors.is_roommate && <span className="error">{errors.is_roommate}</span>}
                        {formData?.is_roommate && formData?.is_roommate === "1" &&
                            <>
                                <div className="form-item">
                                    <label for="roommate_id" className="form-label">{t("accomodation.Roommate_ID")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="roommate_id"
                                        placeholder=""
                                        value={formData.roommate_id || ""}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                {errors.roommate_id && <span className="error">{errors.roommate_id}</span>}
                                <div className="form-item">
                                    <label for="roommate_name" className="form-label">{t("accomodation.Roommate_Name")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="roommate_name"
                                        placeholder=""
                                        value={formData.roommate_name || ""}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                {errors.roommate_name && <span className="error">{errors.roommate_name}</span>}
                                <div className="form-item">
                                    <label for="roommate_relationship" className="form-label">{t("accomodation.Roommate_Relationship")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="roommate_relationship"
                                        placeholder=""
                                        value={formData.roommate_relationship || ""}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                {errors.roommate_relationship && <span className="error">{errors.roommate_relationship}</span>}
                            </>
                        }
                    </>
                }
            />
            <CustomModal
                hideModal={toggleChangeStayDateModal}
                open={isChangeStayDateModalOpen}
                performAction={closeChangeStayDateModal}
                title={t("accomodation.UpdateInformation")}
                confirmLoading={isSubmitting}
                children={
                    <p>
                        {t("accomodation.Confirmation")}
                    </p>
                }
            />
            {!formData || !originalData || !roomQuantity ?
                <div className='info-container'>
                    <h3>{t("accomodation.title")}</h3>
                    <p>
                        {
                            languageSelected === "en"
                                ? courseData.course_ename
                                : courseData.course_cname
                        }
                    </p>
                    {isLoading ?
                        <>
                            <AiOutlineLoading className='spin' />
                            <p>{t("accomodation.Loading_form")}</p>
                        </>
                        :
                        <>
                            <p style={{ "color": "#ff0000" }}><Trans key="accomodation" html="br:<br/>">
                                <br />{t("accomodation.EmptyForm")}
                            </Trans></p>
                            <div className='action-buttons'>
                                <Link to={`${base_url}/retreat-accommodation`}>
                                    <Button
                                        buttonStyle='btn--primary'
                                        buttonSize='btn--small'
                                    >{t("accomodation.SubmitForm")}</Button>
                                </Link>

                            </div>
                        </>
                    }
                </div>
                :
                <>
                    <div className='info-container'>
                        <h3>{t("accomodation.title")}</h3>
                        <p>
                            {
                                languageSelected === "en"
                                    ? courseData.course_ename
                                    : courseData.course_cname
                            }
                        </p>
                        <Button
                            buttonStyle='btn--primary'
                            buttonSize='btn--small'
                            onClick={handleDownloadConfirmation}
                            disabled={originalData.is_open_download_hotel_form === '0'}
                        >
                            <FaFilePdf className="me-2" />
                            {t("accomodation.DownloadConfirmation")}
                        </Button>
                        {originalData.has_finance_error && <p class="error mt-1">{t("accomodation.taxRefund")}</p>}
                    </div>
                    {!isEditing ?
                        <>
                            <div className='form-wrapper mt-3'>
                                <h3 className='mt-2'></h3>
                                <p><strong>
                                    {t("accomodation.informationSTAY")}<br />
                                    {originalData.room_type_assigned !== null && originalData.room_type_assigned !== "" &&
                                        <span className='error'>{t("accomodation.ROOMassign")}</span>
                                    }
                                </strong>
                                </p>
                                <table className="table table-light">
                                    <thead>
                                        <tr>
                                            <th scope="col">{t("accomodation.TitleSTAY")}</th>
                                            <th scope="col">{t("accomodation.ItemSelected")}</th>
                                            <th className='action-table-row' scope="col">{t("accomodation.Action")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>{t("accomodation.RoomDecide")}</th>
                                            <td>{invoiceItemCopy.find(i => i.key === originalData?.room_type).title}</td>
                                            <td className='action-table-row'>
                                                <button onClick={toggleChangeRoomModal} className="action-button"><CgArrowsExchangeAlt className='fs-3' /></button>
                                            </td>
                                        </tr>
                                        {/* <tr>
                                            <th>{t("accomodation.RoomGiven")}</th>
                                            <td><span className='error'>
                                                {
                                                    originalData.room_type_assigned !== null &&
                                                        originalData.room_type_assigned !== "" ?
                                                        invoiceItemCopy.find(i => i.key === originalData?.room_type_assigned).title
                                                        :
                                                        t("interview.DecideYET")
                                                }
                                            </span></td>
                                            <td></td>
                                        </tr> */}
                                        {/* is add on bed commentted out
                                        <tr>
                                            <th>
                                                {t("accomodation.AddON")}
                                                <IoInformationCircle data-tooltip-id="bed_tooltip" />
                                            </th>
                                            <td>{originalData.is_addon_bed === "1" ? t("general.yes") : t("general.no")}</td>
                                            <td className='action-table-row'>
                                                <button onClick={toggleAddOnBedModal} className="action-button"><FaBed className='fs-4' /></button>
                                            </td>
                                        </tr> */}
                                        <tr>
                                            <th>{t("accomodation.StayDuration")}</th>
                                            <td>{originalData.check_in_date} - {originalData.check_out_date}</td>
                                            <td className='action-table-row'>
                                                <button onClick={toggleChangeStayDateModal} className="action-button"><FaEdit className='fs-4' /></button>
                                            </td>
                                        </tr>
                                        {
                                            (originalData.room_type === "king_2p" || originalData.room_type === "twin_2p") &&
                                            <tr>
                                                <th>{t("accomodation.ROOMMATEtitle")}</th>
                                                <td>
                                                    {originalData.is_roommate === "1" ?
                                                        <>{originalData.roommate_id}-{originalData.roommate_name}（{originalData.roommate_relationship}）</>
                                                        : t("interview.DecideYET")}
                                                </td>
                                                <td className='action-table-row'>
                                                    <button onClick={toggleChangeRoommateModal} className="action-button"><FaEdit className='fs-4' /></button>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                                <AccommodationOption />
                                <div className="image-radio-container">
                                    <div className="room-radio-option">
                                        <span>
                                            <img
                                                src={`${base_url}/images/twinroom.JPG`}
                                                alt={t("Constant.TwinRoom")}
                                            />
                                        </span>
                                        <p>{t("Constant.TwinRoom")} (MYR {twinRoom2PPrice})</p>
                                    </div>
                                    <div className="room-radio-option">
                                        <span>
                                            <img
                                                src={`${base_url}/images/kingroom.JPG`}
                                                alt={t("Constant.KingRoomDoubleOccupancy")}
                                            />
                                        </span>
                                        <p>{t("Constant.KingRoomDoubleOccupancy")} (MYR {twinRoom2PPrice})</p>
                                    </div>
                                    <div className="room-radio-option">
                                        <span>
                                            <img
                                                src={`${base_url}/images/kingroom.JPG`}
                                                alt={t("Constant.KingRoom")}
                                            />
                                        </span>
                                        <p>{t("Constant.KingRoom")} (MYR {kingRoom1PPrice})</p>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <div className="form-wrapper">
                                <>
                                    <div className='action-buttons d-flex justify-content-center'>
                                        <Button
                                            buttonStyle='btn--primary'
                                            buttonSize='btn--small'
                                            onClick={handleCancel}
                                        >{t("general.BTNcancel")}</Button>
                                    </div>
                                    <form>
                                        <div className="form-item mt-5">
                                            <label>
                                                <span style={{ color: "#ff0000", fontSize: "20px" }}>{t("accomodation.RoomType")}*</span>
                                            </label>
                                            <div className="image-radio-container">
                                                <div className="image-radio-container">
                                                    <button
                                                        type='button'
                                                        disabled={isRoomDisabled('doubleroom')}
                                                        className={`room-radio-option ${selectedRoom === 'twin_2p' ? 'selected' : ''} ${isRoomDisabled('doubleroom') ? 'disabled' : ''}`}
                                                        onClick={() => handleRoomSelection('twin_2p')}
                                                    >
                                                        <span>
                                                            <img
                                                                src={`${base_url}/images/twinroom.JPG`}
                                                                alt={t("Constant.TwinRoom")}
                                                            />
                                                            {selectedRoom === 'twin_2p' && <div className="tick-icon">✔</div>}
                                                        </span>
                                                        <p>{t("Constant.TwinRoom")} (MYR {twinRoom2PPrice}) {isRoomDisabled('doubleroom') && <span className="error">{t("accomodation.fullyBooked")}</span>}</p>
                                                    </button>
                                                    <button
                                                        type='button'
                                                        disabled={isRoomDisabled('doubleroom')}
                                                        className={`room-radio-option ${selectedRoom === 'king_2p' ? 'selected' : ''} ${isRoomDisabled('doubleroom') ? 'disabled' : ''}`}
                                                        onClick={() => handleRoomSelection('king_2p')}
                                                    >
                                                        <span>
                                                            <img
                                                                src={`${base_url}/images/kingroom.JPG`}
                                                                alt={t("Constant.KingRoomDoubleOccupancy")}
                                                            />
                                                            {selectedRoom === 'king_2p' && <div className="tick-icon">✔</div>}
                                                        </span>
                                                        <p>{t("Constant.KingRoomDoubleOccupancy")} (MYR {twinRoom2PPrice}) {isRoomDisabled('doubleroom') && <span className="error">{t("accomodation.fullyBooked")}</span>}</p>
                                                    </button>
                                                    <button
                                                        type='button'
                                                        disabled={isRoomDisabled('singleroom')}
                                                        className={`room-radio-option ${selectedRoom === 'king_1p' ? 'selected' : ''} ${isRoomDisabled('singleroom') ? 'disabled' : ''}`}
                                                        onClick={() => handleRoomSelection('king_1p')}
                                                    >
                                                        <span>
                                                            <img
                                                                src={`${base_url}/images/kingroom.JPG`}
                                                                alt={t("Constant.KingRoom")}
                                                            />
                                                            {selectedRoom === 'king_1p' && <div className="tick-icon">✔</div>}
                                                        </span>
                                                        <p>{t("Constant.KingRoom")} (MYR {kingRoom1PPrice}) {isRoomDisabled('singleroom') && <span className="error">{t("accomodation.fullyBooked")}</span>}</p>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-item">
                                            <label for="checkin-period" className="form-label">{t("accomodation.Previous_Period")}</label>
                                            <input type="text" className="form-control" id="ori_stay_days" readOnly
                                                value={`${format(originalData.check_in_date, 'dd-MM-yyyy')}  to  ${format(originalData.check_out_date, 'dd-MM-yyyy')}`}
                                            />
                                        </div>
                                        <div className='d-flex gap-3'>
                                            <div className='form-item'>
                                                <label for="check_in_date" className="form-label">{t("accomodation.checkInDate")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                <input
                                                    type='date'
                                                    id="check_in_date"
                                                    onChange={handleInputChange}
                                                    value={formData.check_in_date}
                                                    min={
                                                        dayjs(courseData.start_datetime)
                                                            .utc()
                                                            .subtract(5, "day")
                                                            .format("YYYY-MM-DD")
                                                    }
                                                    max={
                                                        dayjs(courseData.start_datetime)
                                                            .utc()
                                                            .format("YYYY-MM-DD")
                                                    }
                                                />
                                            </div>
                                            {errors.check_in_date && <p className='m-0'><span className="error">{errors.check_in_date}</span></p>}
                                            <div className='form-item'>
                                                <label for="check_out_date" className="form-label">{t("accomodation.checkOutDate")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                <input
                                                    type='date'
                                                    id="check_out_date"
                                                    onChange={handleInputChange}
                                                    value={formData.check_out_date}
                                                    min={
                                                        dayjs(courseData.end_datetime)
                                                            .utc()
                                                            .format("YYYY-MM-DD")
                                                    }
                                                    max={
                                                        dayjs(courseData.end_datetime)
                                                            .utc()
                                                            .add(1, "day")
                                                            .format("YYYY-MM-DD")
                                                    }
                                                />
                                            </div>
                                            {errors.check_out_date && <p className='m-0'><span className="error">{errors.check_out_date}</span></p>}
                                        </div>

                                        <h4 className='mt-4'>{t("accomodation.CheckoutAmount")}</h4>
                                        <table className="table table-light table-info">
                                            <thead>
                                                <tr>
                                                    <th scope="col">{t("accomodation.AmtTitle")}</th>
                                                    <th scope="col">{t("accomodation.AmtItem")}</th>
                                                    <th scope="col">{t("accomodation.AMT")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th className='th-row' scope="row">{t("accomodation.Roomselect")}</th>
                                                    <td>{invoiceItemCopy.filter((item) => item.key === formData.room_type).map((item) => item.title)}</td>
                                                    <td>MYR {checkoutItem.roomDifferentAmount}</td>
                                                </tr>
                                                <tr>
                                                    <th className='th-row' scope="row">{t("accomodation.STAYb4")}</th>
                                                    <td>{totalStayDaysBefore} {t("accomodation.days")} {totalStayDaysBefore - 1} {t("accomodation.nights")}</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <th className='th-row' scope="row">{t("accomodation.Staynow")}</th>
                                                    <td>{totalStayDaysNow} {t("accomodation.days")} {totalStayDaysNow - 1} {t("accomodation.nights")}</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <th className='th-row' scope="row">{t("accomodation.DayAmount")}</th>
                                                    <td>{differentStayDays} {t("accomodation.nights")}</td>
                                                    <td>MYR {checkoutItem.amountDifference}</td>
                                                </tr>
                                                <tr>
                                                    <th className='th-row' scope="row">{t("accomodation.TourismTax")}</th>
                                                    <td>{passportRegion === "Malaysia" ? t("accomodation.msia") : `${differentStayDays} ${t("accomodation.nights")}`}</td>
                                                    <td>MYR {checkoutItem.tourismTax}</td>
                                                </tr>
                                                {/* <tr>
                                                    <th className='th-row' scope="row">{t("accomodation.TransactionFees")}</th>
                                                    <td>{formData.payment_mode === "creditcard" ? t("accomodation.CreditCard") : t("accomodation.OfflineTransfer")}</td>
                                                    <td>MYR {transactionFee}</td>
                                                </tr> */}
                                                <tr>
                                                    <th className='th-row' scope="row">{t("accomodation.sustainabilityFee")}</th>
                                                    <td>{differentStayDays} {t("accomodation.nights")}</td>
                                                    <td>MYR {checkoutItem.sustainabilityFee}</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td className='th-row'><strong>{t("accomodation.TotalRM")} ({t("accomodation.myr")})</strong></td>
                                                    <td><strong>{totalAmount.totalAmount}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td className='th-row'><strong>{t("accomodation.TotalCurrency")} ({currencySelected.key || "MYR"})</strong></td>
                                                    <td><strong>{totalAmount.totalAmountInCurrencySelected}</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        {totalAmount.totalAmount > 0 &&
                                            <>
                                                <div className="form-item">
                                                    <label>{t("accomodation.PaymentMethod")}
                                                        <span style={{ "color": "#ff0000" }}>*</span></label>
                                                    <div className='radio'>
                                                        <input className="form-check-input p-2" type="radio" name="payment_mode" id="stripe" onChange={handleInputChange} required />
                                                        <p className='radioLabel mb-0'>{t("accomodation.Method1")}</p>
                                                    </div>
                                                    <div className='radio'>
                                                        <input className="form-check-input p-2" type="radio" name="payment_mode" id="offline" onChange={handleInputChange} required />
                                                        <p className='radioLabel mb-0'>{t("accomodation.Method2")}<span style={{ color: "#ff0000" }}>&nbsp;{t("accomodation.Method2Remind")}</span></p>
                                                    </div>
                                                </div>
                                                {errors.payment_mode && <span className="error">{errors.payment_mode}</span>}
                                                {paymentMethod === "offline" &&
                                                    <>
                                                        <div className="form-item">
                                                            <label>{t("accomodation.cURRENCY")}
                                                                <span style={{ "color": "#ff0000" }}>*</span></label>
                                                            <select className="form-select" onChange={handleCurrencyChange} id="offline_payment_currency" required>
                                                                <option value="">{t("accomodation.ChooseCurrency")}</option>
                                                                {currencyCopy.map((item, index) => (
                                                                    <option key={index} value={item.key}>{item.currency}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        {errors.offline_payment_currency && <span className="error">{errors.offline_payment_currency}</span>}
                                                        {
                                                            currencySelected !== "" &&
                                                            bankInfoCopy
                                                                .filter((i) => i.key === currencySelected.key)
                                                                .map((i, index) => (
                                                                    <div className='section-title mb-2 mt-4' key={index}>
                                                                        <p>
                                                                            <strong>{i.title}</strong>
                                                                            <br />
                                                                            {i.subtitle}
                                                                            <br />
                                                                            {i.bank && <>{t("accomodation.bank")} {i.bank}<br /></>}
                                                                            {i.image && <><img src={i.image} style={{ "width": "250px" }} alt="" /><br /></>}
                                                                            {i.account && <>{t("accomodation.acc_Num")} {i.account} <br /></>}
                                                                            {i.name && <>{t("accomodation.acc_Name")} {i.name}<br /></>}
                                                                            {i.shiftcode && `SWIFT Code: ${i.shiftcode}`}
                                                                        </p>
                                                                    </div>
                                                                ))
                                                        }
                                                        <div className="form-item">
                                                            <label for="transaction-prove" className="form-label">
                                                                {t("accomodation.Upload_Res")}
                                                                <span style={{ "color": "#ff0000" }}>*</span></label>
                                                            {
                                                                previews.offline_payment_prove &&
                                                                <img src={previews.offline_payment_prove} className="img-thumbnail mt-3" style={{ maxWidth: "200px" }} />
                                                            }
                                                            <input
                                                                type="file"
                                                                className="form-control"
                                                                onChange={handleFileChange}
                                                                id="offline_payment_prove"
                                                            />
                                                        </div>
                                                        <div className="form-info mt-2">
                                                            <p className='mb-0'>{t("general.smallerFile")}</p>
                                                        </div>
                                                        {fileError?.offline_payment_prove && <div className="error mt-2">{fileError?.offline_payment_prove}</div>}
                                                        {errors.offline_payment_prove && <span className="error">{errors.offline_payment_prove}</span>}
                                                    </>
                                                }
                                                {paymentMethod === "stripe" &&
                                                    <Elements
                                                        stripe={stripePromise}
                                                        options={{
                                                            mode: "payment",
                                                            // amount: convertToSubcurrency(((Number(netTotalAmount) + Number(checkoutItem.tourismTax) + 1) / 0.96).toFixed(2)),
                                                            amount: convertToSubcurrency(Object.values(checkoutItem).reduce((sum, val) => sum + Number(val || 0), 0).toFixed(2)),
                                                            currency: "myr",
                                                        }}
                                                    >
                                                        <Checkout
                                                            amount={(Object.values(checkoutItem).reduce((sum, val) => sum + Number(val || 0), 0)).toFixed(2)}
                                                            formData={setNullFormToEmpty(formData)}
                                                            validateAllFields={validateAllFields}
                                                            checkoutItem={checkoutItem}
                                                            // uncommented for transaction fee removal
                                                            // transactionFee={Number(((0.04 * (Number(netTotalAmount) + Number(checkoutItem.tourismTax)) + 1) / 0.96))}
                                                            netTotalAmount={Number(netTotalAmount)}
                                                            generateValidationFields={generateValidationFields}
                                                            isFull={isFull}
                                                            topUp={true}
                                                        />
                                                    </Elements>
                                                }
                                            </>
                                        }
                                        {totalAmount.totalAmount < 0 &&
                                            <span className='error'>{t("accomodation.confirmREFUND")}</span>
                                        }
                                        <div className='button-container mt-3'>
                                            <Button buttonStyle="btn--primary" onClick={handleSubmit} hidden={paymentMethod === "stripe"} type="button">
                                                {isSubmitting ? <AiOutlineLoading className="spin" /> : t("general.BTNsubmit")}
                                            </Button>
                                        </div>
                                    </form>
                                </>
                            </div>
                        </>
                    }
                </>
            }
            <Tooltip
                id="bed_tooltip"
                place="top"
                content={t("accomodation.ApplicableContent")}
            />
        </>

    )
}

export default ViewAccomodation